import React from 'react';
import { Router } from 'react-router-dom';
import PropTypes from 'prop-types';
import { render } from '@testing-library/react';
// eslint-disable-next-line
import { createMemoryHistory } from 'history';

export function formatPhoneNumber(phoneNumberString) {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

export default function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getGrowthPercentage(firstValue, secondValue, digits = 2) {
  if (firstValue === 0) {
    return 100;
  }
  if (!((secondValue * 100) / firstValue - 100)) {
    return 0;
  }
  return ((secondValue * 100) / firstValue - 100).toFixed(digits);
}

export function renderWithRouter(
  ui,
  { route = '/', history = createMemoryHistory({ initialEntries: [route] }) } = {}
) {
  const Wrapper = ({ children }) => <Router history={history}>{children}</Router>;
  Wrapper.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  };
  return {
    ...render(ui, { wrapper: Wrapper }),
    history,
  };
}

export const dateSortAsc = (date1, date2) => {
  // This is a comparison function that will result in dates being sorted in
  // ASCENDING order. As you can see, JavaScript's native comparison operators
  // can be used to compare dates. This was news to me.
  if (date1 > date2) return 1;
  if (date1 < date2) return -1;
  return 0;
};
export const sortArrayOfDates = (arr, monthLength = 'short') => {
  const overallMonths = [];
  arr.forEach((key) => {
    overallMonths.push(new Date(`01 ${key}`));
  });
  overallMonths.sort(dateSortAsc);
  overallMonths.forEach((item, index) => {
    overallMonths[index] = `${encodeURIComponent(
      item.toLocaleString('en-US', { month: monthLength })
    )} ${item.getFullYear()}`;
  });
  return overallMonths;
};

export const fallbackCopyTextToClipboard = (text, cb = () => {}) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const successful = document.execCommand('copy');
    // const msg = successful ? 'successful' : 'unsuccessful';
    // console.log(`Fallback: Copying text command was ${msg}`);
    if (successful) {
      cb();
    }
  } catch (e) {
    //
  }
  document.body.removeChild(textArea);
};

export const copyTextToClipboard = (text, cb = () => {}) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, cb);
    return;
  }
  navigator.clipboard.writeText(text).then(() => {
    cb();
  });
};

export const combineObjects = (obj1, obj2) => {
  const combinedObj = { ...obj1 };

  Object.keys(obj2).forEach((key) => {
    combinedObj[key] = (combinedObj[key] || 0) + obj2[key];
  });

  return combinedObj;
};